import { useLanguage } from '../contexts/LanguageContext';
import { translations, getTranslation } from '../translations';

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (path, params = {}) => {
    let translation = getTranslation(translations, language, path);
    
    // Replace parameters in the translation string
    if (typeof translation === 'string') {
      Object.keys(params).forEach(key => {
        translation = translation.replace(`{${key}}`, params[key]);
      });
    }
    
    return translation;
  };

  return { t, language };
};